import Model from "../Model";

export type BroadcasterExclusivityType = "mine" | "others" | "shared";

export type BroadcastersCollection = {
  broadcastersAll: Broadcaster[];
  broadcastersAllWithModules?: Broadcaster[];
  broadcastersMine: Broadcaster[];
  broadcastersOthers: Broadcaster[];
  broadcastersShared: Broadcaster[];
};

export type BroadcastersCatalog = {
  [key: string]: BroadcastersCollection;
};

export default class Broadcaster extends Model {
  static type = "broadcasters";

  brandName!: string;
  secondsCount!: number;
  detectionsCount!: number;
  companiesCount!: number;
  companyIds!: string;
  productsCount!: number;
  marketSegment!: string;
  publisher!: string;
  currentAgency!: string;
  mediaType!: string;
  exclusivityType!: BroadcasterExclusivityType;
  moduleName?: string;
  broadcastName?: string;
  broadcastId?: number;
  campaignableType?: string;
  moduleTypology?: string;
  timeGranularity?: string;
  iconUrl?: string;

  get name() {
    return this.brandName;
  }

  get type(): string {
    return Broadcaster.type;
  }

  get logoUrls(): string[] {
    if (this.iconUrl) {
      return [this.iconUrl];
    } else return [];
  }
}
